import { render } from "./App.vue?vue&type=template&id=46074f8b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=46074f8b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46074f8b"

export default script